import "regenerator-runtime/runtime";
import _asyncToGenerator from "/root/workspace/admin_admin-web_uLO7/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { getSellerList, getShopDataAnalyse, shopDataDownload } from '@/api/bairun/bianlidian'; //  此处请自行替换地址

import infoList from '@/mixins/infoList';
import * as DateUtil from '@/utils/date';
import { saveAs } from 'file-saver';

var _this;

export default {
  name: 'BairunBianlidianStockAnalyse',
  filters: {
    formatDate: function formatDate(time) {
      if (time != null && time !== '') {
        var date = new Date(time);
        return DateUtil.formatTimeToStr(date, 'yyyy-MM-dd hh:mm:ss');
      } else {
        return '';
      }
    },
    formatDate2: function formatDate2(time) {
      if (time != null && time !== '') {
        var date = new Date(time);
        return DateUtil.formatTimeToStr(date, 'yyyy-MM-dd');
      } else {
        return '';
      }
    },
    formatBoolean: function formatBoolean(bool) {
      if (bool != null) {
        return bool ? '是' : '否';
      } else {
        return '';
      }
    },
    getSellerShortName: function getSellerShortName(sellerId) {
      if (sellerId == 0) {
        return '总';
      }

      for (var i = 0; i < _this.sellerOptions.length; i++) {
        if (_this.sellerOptions[i].sellerId === sellerId) {
          return _this.sellerOptions[i].shortSellerName;
        }
      }

      return '';
    }
  },
  mixins: [infoList],
  data: function data() {
    return {
      listApi: '',
      type: '',
      searchInfo: {
        sellerId: 0,
        goodsName: ''
      },
      sellerOptions: [],
      showSelSeller: false,
      checkTab: 'shishi',
      shishiTable: {
        table: [],
        page: 1,
        pageSize: 10
      },
      linqiTable: {
        table: [],
        page: 1,
        pageSize: 10
      },
      jiyaTable: {
        table: [],
        page: 1,
        pageSize: 10
      },
      guoqiTable: {
        table: [],
        page: 1,
        pageSize: 10
      }
    };
  },
  beforeCreate: function beforeCreate() {
    _this = this;
  },
  activated: function activated() {// 使用keepalive的页面,重新展示都会调用

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  created: function created() {
    var _this2 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              // 使用keepalive的页面,重新展示不会调用
              console.log('created');

              _this2.init();

            case 2:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }))();
  },
  methods: {
    init: function init() {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var sellerOptions;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return getSellerList({
                  page: 1,
                  pageSize: 999999,
                  sellerSource: 1,
                  donNotShowLoading: true
                });

              case 2:
                sellerOptions = _context3.sent;
                _this3.sellerOptions = sellerOptions.data.list;

                if (_this3.sellerOptions.length === 1) {
                  _this3.sellerId = _this3.sellerOptions[0].sellerId;
                }

                _this3.onSubmit();

              case 6:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    },
    onInputChange: function onInputChange() {
      this.$forceUpdate();
    },
    // 条件搜索前端看此方法
    onSubmit: function onSubmit() {
      this.page = 1;
      this.pageSize = 10;
      this.showSelSeller = false;
      this.onCheckTab();
      this.$forceUpdate();
    },
    onCheckTab: function onCheckTab() {
      var _this4 = this;

      if (this.checkTab === 'shishi') {
        this.initShishi();
      }

      if (this.checkTab === 'linqi') {
        this.initLinqi();
      }

      if (this.checkTab === 'jiya') {
        this.initJiya();
      }

      if (this.checkTab === 'guoqi') {
        this.initGuoqi();
      }

      this.$nextTick(function () {
        _this4.$refs.shishiTable && _this4.$refs.shishiTable.doLayout();
        _this4.$refs.linqiTable && _this4.$refs.linqiTable.doLayout();
        _this4.$refs.jiyaTable && _this4.$refs.jiyaTable.doLayout();
        _this4.$refs.guoqiTable && _this4.$refs.guoqiTable.doLayout();
      });
    },
    onDownload: function onDownload() {
      var _this5 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var param, res;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                param = {
                  'sellerId': _this5.searchInfo.sellerId,
                  'period': _this5.searchInfo.period,
                  'timeTag': _this5.searchInfo.timeTag,
                  'startTime': _this5.searchInfo.startTime,
                  'endTime': _this5.searchInfo.endTime,
                  'goodsName': _this5.searchInfo.goodsName
                };

                if (_this5.checkTab === 'shishi') {
                  param.dataType = 5;
                }

                if (_this5.checkTab === 'linqi') {
                  param.dataType = 9;
                }

                if (_this5.checkTab === 'jiya') {
                  param.dataType = 11;
                }

                if (_this5.checkTab === 'guoqi') {
                  param.dataType = 10;
                }

                _context4.next = 7;
                return shopDataDownload(param);

              case 7:
                res = _context4.sent;

                if (res.code == 0) {
                  saveAs(res.data.fileUrl);
                }

              case 9:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }))();
    },
    onViewGoodsInDetail: function onViewGoodsInDetail(row) {
      var params = {
        sellerId: row.sellerId,
        goodsInNo: row.goodsInNo
      };
      this.$router.push({
        name: 'BianlidianGoodsDetail',
        params: params
      });
    },
    // 实时库存
    initShishi: function initShishi() {
      var _this6 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        var param, res;
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                param = {
                  'dataType': 5,
                  'sellerId': _this6.searchInfo.sellerId,
                  'page': _this6.shishiTable.page,
                  'pageSize': _this6.shishiTable.pageSize,
                  'goodsName': _this6.searchInfo.goodsName
                };
                _context5.next = 3;
                return getShopDataAnalyse(param);

              case 3:
                res = _context5.sent;

                if (res.code == 0) {
                  _this6.shishiTable.table = res.data.list || [];
                  _this6.shishiTable.total = res.data.total;
                  _this6.shishiTable.page = res.data.page;
                  _this6.shishiTable.pageSize = res.data.pageSize;

                  _this6.$nextTick(function () {
                    _this6.$refs.shishiTable && _this6.$refs.shishiTable.doLayout();
                  });
                }

              case 5:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }))();
    },
    handleShishiSizeChange: function handleShishiSizeChange(val) {
      this.shishiTable.pageSize = val;
      this.initShishi();
    },
    handleShishiCurrentChange: function handleShishiCurrentChange(val) {
      this.shishiTable.page = val;
      this.initShishi();
    },
    // 临期库存
    initLinqi: function initLinqi() {
      var _this7 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
        var param, res;
        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                param = {
                  'dataType': 9,
                  'sellerId': _this7.searchInfo.sellerId,
                  'page': _this7.linqiTable.page,
                  'pageSize': _this7.linqiTable.pageSize,
                  'goodsName': _this7.searchInfo.goodsName
                };
                _context6.next = 3;
                return getShopDataAnalyse(param);

              case 3:
                res = _context6.sent;

                if (res.code == 0) {
                  _this7.linqiTable.table = res.data.list || [];
                  _this7.linqiTable.total = res.data.total;
                  _this7.linqiTable.page = res.data.page;
                  _this7.linqiTable.pageSize = res.data.pageSize;

                  _this7.$nextTick(function () {
                    _this7.$refs.linqiTable && _this7.$refs.linqiTable.doLayout();
                  });
                }

              case 5:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6);
      }))();
    },
    handleLinqiSizeChange: function handleLinqiSizeChange(val) {
      this.linqiTable.pageSize = val;
      this.initLinqi();
    },
    handleLinqiCurrentChange: function handleLinqiCurrentChange(val) {
      this.linqiTable.page = val;
      this.initLinqi();
    },
    // 积压库存
    initJiya: function initJiya() {
      var _this8 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7() {
        var param, res;
        return regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                param = {
                  'dataType': 11,
                  'sellerId': _this8.searchInfo.sellerId,
                  'page': _this8.jiyaTable.page,
                  'pageSize': _this8.jiyaTable.pageSize,
                  'goodsName': _this8.searchInfo.goodsName
                };
                _context7.next = 3;
                return getShopDataAnalyse(param);

              case 3:
                res = _context7.sent;

                if (res.code == 0) {
                  _this8.jiyaTable.table = res.data.list || [];
                  _this8.jiyaTable.total = res.data.total;
                  _this8.jiyaTable.page = res.data.page;
                  _this8.jiyaTable.pageSize = res.data.pageSize;

                  _this8.$nextTick(function () {
                    _this8.$refs.jiyaTable && _this8.$refs.jiyaTable.doLayout();
                  });
                }

              case 5:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7);
      }))();
    },
    handleJiyaSizeChange: function handleJiyaSizeChange(val) {
      this.jiyaTable.pageSize = val;
      this.initJiya();
    },
    handleJiyaCurrentChange: function handleJiyaCurrentChange(val) {
      this.jiyaTable.page = val;
      this.initJiya();
    },
    // 过期库存
    initGuoqi: function initGuoqi() {
      var _this9 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8() {
        var param, res;
        return regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                param = {
                  'dataType': 10,
                  'sellerId': _this9.searchInfo.sellerId,
                  'page': _this9.guoqiTable.page,
                  'pageSize': _this9.guoqiTable.pageSize,
                  'goodsName': _this9.searchInfo.goodsName
                };
                _context8.next = 3;
                return getShopDataAnalyse(param);

              case 3:
                res = _context8.sent;

                if (res.code == 0) {
                  _this9.guoqiTable.table = res.data.list || [];
                  _this9.guoqiTable.total = res.data.total;
                  _this9.guoqiTable.page = res.data.page;
                  _this9.guoqiTable.pageSize = res.data.pageSize;

                  _this9.$nextTick(function () {
                    _this9.$refs.guoqiTable && _this9.$refs.guoqiTable.doLayout();
                  });
                }

              case 5:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8);
      }))();
    },
    handleGuoqiSizeChange: function handleGuoqiSizeChange(val) {
      this.guoqiTable.pageSize = val;
      this.initGuoqi();
    },
    handleGuoqiCurrentChange: function handleGuoqiCurrentChange(val) {
      this.guoqiTable.page = val;
      this.initGuoqi();
    }
  }
};